import type Uppy from "@uppy/core";
import type {Meta, Body, UppyFile} from "@uppy/core";
import type ImageEditor from "@uppy/image-editor";

/** Save pending edits before uploading; an inactive editor emits no completion event. */
export async function saveActiveImageEditor<M extends Meta, B extends Body>(uppy: Uppy<M, B>): Promise<void> {
    const editor = uppy.getPlugin<ImageEditor<M, B>>("ImageEditor");
    const state = editor?.getPluginState();
    if (!state?.currentImage) return;
    if (!state.cropperReady) throw new Error("The image editor is still loading. Please try again shortly.");

    await new Promise<void>((resolve, reject) => {
        const completed = (file: UppyFile<M, B>) => {
            if (file.id !== state.currentImage.id) return;
            clearTimeout(timeout);
            uppy.off("file-editor:complete", completed);
            resolve();
        };
        const timeout = setTimeout(() => {
            uppy.off("file-editor:complete", completed);
            reject(new Error("The image editor could not finish saving. Please try again."));
        }, 10000);
        uppy.on("file-editor:complete", completed);
        try {
            editor.save();
        } catch (error) {
            clearTimeout(timeout);
            uppy.off("file-editor:complete", completed);
            reject(error);
        }
    });
}
